import moment from 'moment-timezone';

// a single availability slot
export default class AvailabilitySlot {

  static get defaults() {
    return {
      // IANA timezone
      timezone: 'America/New_York'
    };
  }

  /**
   * AvailabilitySlot constructor
   * @method constructor
   * @param  {String|Date|Number} start    – slot start time
   * @param  {String|Date|Number} finish   – slot end time
   * @param  {Number}             duration – appt duration (mins)
   * @return {AvailabilitySlot}
   */

  constructor( start, finish, duration, opts = {} ) {
    this._options = Object.assign( {}, AvailabilitySlot.defaults, opts );
    this._start = new Date( start );
    this._finish = new Date( finish );
    this._duration = duration || 60;
  }

  // copy of start time
  get start() {
    return new Date( this._start );
  }

  // copy of end time
  get finish() {
    return new Date( this._finish );
  }

  // appointment duration in minutes
  get duration() {
    return this._duration;
  }

  // Date object representing the start of the day in which the slot falls
  get dayStart() {
    const date = this.start;

    date.setHours( 0 );
    date.setMinutes( 0 );
    date.setSeconds( 0 );
    date.setMilliseconds( 0 );

    return date;
  }

  // pretty date
  get pretty() {
    const date = moment( this.start ).tz( this._options.timezone );
    return date.format('h:mm a');
  }

  // Date object representing the end of the day in which the slot falls
  get dayFinish() {
    const date = this.dayStart;
    return new Date( date.getTime() + 1000 * 60 * 60 * 24 );
  }

}
